import { Button, Checkbox, Form, Input, InputNumber, message, Popconfirm, Select } from "antd";
import { useEffect, useState } from "react";
import { serverFetch } from "../../../server";
import { CloseCircleOutlined } from "@ant-design/icons";

const defaultItem = { active: true, price: 0, idx: 0, bestSeller: false, bestPrice: false, action: false };

const CatalogItem = ({ id, groupId, onClose }) => {
  const [item, setItem] = useState({ ...defaultItem, catalogGroupId: groupId });
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [groups, setGroups] = useState([]);
  const [products, setProducts] = useState([]);
  const [productLoading, setProductLoading] = useState(false);

  const getData = () => {
    Promise.all([
      serverFetch("Catalog/Groups").then(data => setGroups(data.map(g => ({ value: g.id, label: g.name })))),
      serverFetch("product/ForSale?active=true").then(data => {
        setProducts(data.map(p => ({ value: p.id, label: p.name, price: p.expPrice })));
        setProductLoading(false);
      }).catch(() => setProductLoading(false))
    ]).catch(e => message.error(e.userMessage));

    if (id) {
      setLoading(true);
      serverFetch(`Catalog/Items/${id}`)
        .then(data => {
          const itemData = { ...data, idx: data.idx ?? 0 };
          setItem(itemData);
          form.setFieldsValue(itemData);
          setLoading(false);
        })
        .catch(e => {
          setLoading(false);
          message.error(e.userMessage);
        });
    } else {
      const defaultItemData = { ...defaultItem, catalogGroupId: groupId };
      setItem(defaultItemData);
      form.setFieldsValue(defaultItemData);
    }
  };

  useEffect(() => {
    setProductLoading(true);
    getData();
  }, [id, groupId, form]); // eslint-disable-line react-hooks/exhaustive-deps

  const onValuesChange = (value) => {
    if (value.productId) {
      const selectedProduct = products.find(p => p.value === value.productId);
      if (selectedProduct) {
        value = { ...value, name: selectedProduct.label, price: selectedProduct.price || 0 };
        form.setFieldsValue({ name: selectedProduct.label, price: selectedProduct.price || 0 });
      }
    }
    setItem({ ...item, ...value });
  };

  const onSave = () => {
    form.validateFields().then(() => {
      setLoading(true);
      serverFetch("Catalog/Items", { method: id ? "PUT" : "POST", bodyData: { ...item, idx: item.idx ?? 0 } })
        .then(() => onClose(true))
        .catch(e => {
          setLoading(false);
          message.error(e.userMessage);
        });
    });
  };

  const onDelete = () => {
    setLoading(true);
    serverFetch(`Catalog/Items/${id}`, { method: "DELETE" })
      .then(() => {
        message.success("Элемент удален");
        onClose(true);
      })
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      });
  };

  return (
    <div className="sport-modal">
      <div
        className="sport-modal-overlay"
        onMouseDown={e => e.target === e.currentTarget && onClose(false)}
      >
        <div
          className="sport-modal-content"
          style={{ width: 600 }}
          onMouseDown={e => e.stopPropagation()}
        >
          <div className="sport-modal-title">
            <span>Элемент каталога</span>
            <CloseCircleOutlined className="sport-section-title-close" onClick={() => onClose()} />
          </div>
          <Form form={form} onValuesChange={onValuesChange} labelCol={{ span: 8 }} wrapperCol={{ span: 24 }} colon={false} disabled={loading}>
            <Form.Item label="Группа" name="catalogGroupId" rules={[{ required: true, message: "Выберите группу" }]}>
              <Select options={groups} disabled={!!groupId} />
            </Form.Item>
            <Form.Item label="Товар" name="productId">
              <Select options={products} loading={productLoading} placeholder="Выберите товар (необязательно)" allowClear showSearch
                filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())} />
            </Form.Item>
            <Form.Item label="Порядок" name="idx" rules={[{ required: true, message: "Введите порядок" }]}>
              <InputNumber style={{ width: "100%" }} min={0} precision={0} placeholder="0" />
            </Form.Item>
            <Form.Item label="Наименование" name="name" rules={[{ required: true, message: "Введите наименование" }]}>
              <Input />
            </Form.Item>
            <Form.Item label="Описание" name="description">
              <Input.TextArea rows={4} />
            </Form.Item>
            <Form.Item label="Цена" name="price" rules={[{ required: true, message: "Введите цену" }]}>
              <InputNumber style={{ width: "100%" }} min={0} step={0.01} precision={2}
                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}
                parser={value => value.replace(/\s?/g, '')} />
            </Form.Item>
            <Form.Item name="active" valuePropName="checked" label=" "><Checkbox>Активный</Checkbox></Form.Item>
            <Form.Item name="bestSeller" valuePropName="checked" label=" "><Checkbox>Лидер продаж</Checkbox></Form.Item>
            <Form.Item name="bestPrice" valuePropName="checked" label=" "><Checkbox>Лучшая цена</Checkbox></Form.Item>
            <Form.Item name="action" valuePropName="checked" label=" "><Checkbox>Акция</Checkbox></Form.Item>
            <Form.Item label=" ">
              <div style={{ display: "flex", gap: "8px" }}>
                <Button className="sport-btn" onClick={onSave} loading={loading}>Сохранить</Button>
                {id ? (
                  <Popconfirm title="Удалить элемент?" description="Это действие нельзя отменить" onConfirm={onDelete} okText="Да" cancelText="Нет">
                    <Button className="sport-btn" danger loading={loading}>Удалить</Button>
                  </Popconfirm>
                ) : null}
                <Button className="sport-btn" onClick={() => onClose()}>Закрыть</Button>
              </div>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default CatalogItem;

